import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { appActions } from '../../../actions';

import AdminPageLayout from '../layout';
import SectorForm from '../sector-edit/form';

import PortalApi from '../../../services/PortalApi';
import Utils from '../../../services/Utils';

class SectorIndexPage extends React.PureComponent {
  state = {
    sectors: [],
  }

  async componentDidMount() {
    await this.loadSectors();
    this.props.finishLoading();
  }

  loadSectors = async () => {
    const sectors = await PortalApi.admin.getSectors();
    this.setState({
      sectors,
    });
  }

  renderSectorList = () => {
    const { sectors } = this.state;

    const columns = [
      {
        Header: '# ID',
        accessor: row => row.id.toString(),
        id: 'id',
        width: 100,
        Cell: ({ value: id }) => (
          <Link className="edit-link" to={`/admin/sectors/${id}`}>
            {id}
          </Link>
        ),
      },
      {
        Header: 'Name',
        accessor: 'name',
        width: 500,
      },
      {
        Header: 'Last Researched At',
        accessor: 'last_researched_at',
        width: 300,
      },
      {
        Header: 'Research Status',
        id: 'research_status_string',
        accessor: row => row.research_status.status_string,
        width: 500,
      },
    ];

    return (
      <div className="sector-list">
        <ReactTable
          data={sectors}
          columns={columns}
          defaultPageSize={25}
          pageSizeOptions={[10, 25, 50, 100]}
          filterable
          defaultFilterMethod={Utils.reactTableFilterInsensitive}
        />
      </div>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <AdminPageLayout>
          <div className="main-content">
            { this.renderSectorList() }
            <hr />
            <div className="create-sector">
              <h1>Create New Sector</h1>
              <SectorForm mode="create" />
            </div>
          </div>
        </AdminPageLayout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  finishLoading: () => dispatch(appActions.finishLoading()),
});

SectorIndexPage.propTypes = {
  finishLoading: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

const StyledSectorIndexPage = styled(SectorIndexPage)`
  .profession-list {
    margin-bottom: 20px;
  }
`;

export default connect(
  null,
  mapDispatchToProps,
)(StyledSectorIndexPage);
